"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assert = function (options, requiredKeys) {
    requiredKeys.forEach(function (key) {
        if (!options[key]) {
            throw new TypeError("Required \"" + key + "\" not defined");
        }
    });
};
//# sourceMappingURL=assert.js.map